$(document).ready ->
  GLOSSARY_FILE_LIMITS = $('#glossary_file_limits').val() && JSON.parse($('#glossary_file_limits').val())

  $('.glossary-category-sortable').sortable({
    cursor: 'move'
  })
  
  file_preview = $(".upload-preview img")
  fileObject = {}
  
  $(".file").change (event) ->
    
    $(".image-preview > #default").css("display", "none")
    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype = file.type;
    fileObject.filename = file.name;
    
    return if fileSizeNotInLimit(file,event,null,GLOSSARY_FILE_LIMITS["image"])

    reader = new FileReader()

    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      
      return
    reader.readAsDataURL file
    return
  return

  
  
  
  